module.exports = __webpack_public_path__ + "static/media/ElectricityLoop.a9bce98c.svg";